import {SuggestionProps} from "@tiptap/suggestion";
import tippy, {Instance, Props} from "tippy.js";
import {SuggestionKeyDownProps} from "@tiptap/suggestion/dist/packages/suggestion/src/suggestion";
import {MentionDTO} from "./MentionDTO";
import SuggestionList from "./SuggestionList";

export default function (globalList:MentionDTO[]){

    return {

        items: (a: { query: string }) => {

            return globalList.filter(item => {
                return item.search.toLowerCase().startsWith(a.query.toLowerCase())
                    || item.search.indexOf(' ' + a.query.toLowerCase()) > 0
            }).slice(0, 100)
        },

        render: () => {

            let popup: Instance<Props>[];
            let list: SuggestionList;

            return {
                onStart: (props: SuggestionProps<MentionDTO>) => {

                    if (!props.clientRect) {
                        return
                    }

                    console.log("ON START", props);

                    var element = document.createElement('div');
                    element.classList.add("tiptap-comment__mentions")

                    popup = tippy('body', {
                        getReferenceClientRect: props.clientRect,
                        appendTo: () => document.body,
                        content: element,
                        showOnCreate: true,
                        interactive: true,
                        trigger: 'manual',
                        placement: 'bottom-start',
                        offset: [0, 2]
                    });

                    list = new SuggestionList(props.items, element, props.command);

                    console.log("POPUP", popup);
                },

                onUpdate: (props: SuggestionProps<MentionDTO>) => {
                    //component.updateProps(props)
                    if (!props.clientRect) {
                        return
                    }

                    console.log("ON UPDATE", props);

                    list.updateContent(props.items, props.command);

                    popup[0].setProps({
                        getReferenceClientRect: props.clientRect,
                    });

                },

                onKeyDown: (props: SuggestionKeyDownProps) => {

                    console.log("ON KEY DOWN", props);

                    if (props.event.key === 'Escape') {
                        popup[0].hide()
                        return true;
                    }

                    if (props.event.key === 'ArrowUp') {
                        list.upHandler()
                        return true
                    }

                    if (props.event.key === 'ArrowDown') {
                        list.downHandler()
                        return true
                    }

                    if (props.event.key === 'Enter') {
                        list.insertMention();
                        return true
                    }

                    return false;
                    //return component.ref?.onKeyDown(props)
                },

                onExit() {
                    popup[0].destroy()
                    //component.destroy()
                },

            }
        },
    }
}
